import axios from "axios";

const state = () => ({
    statistics: null,
    isBusy: false,
    newSegmentParams: null
})

// mutations
const mutations = {
    setBusy(state, data) {
        state.isBusy = data;
    },
    setStatistics(state, data) {
        state.statistics = data;
    },
    newSegmentParams(state, data) {
        state.newSegmentParams = data;
    }
}

// actions
const actions = {
    // eslint-disable-next-line no-unused-vars
    getStatistics({state, commit}, payload) {
        commit('setBusy', true);
        axios.get(`/api/client-security/dashboard-crm-statistics?dateFrom=${payload.startDate}&dateTo=${payload.endDate}`)
            .then(function (response) {
                commit('setStatistics', response.data);
                commit('setBusy', false);
            })
            .catch(error => {
                console.log(error);
            });
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
